import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled from 'styled-components';
import { TbCaretDownFilled } from 'react-icons/tb';
import { Box, Button, Collapse, Flex, Heading, Icon } from 'core/components';
const Caret = styled(Icon).withConfig({
  displayName: "SidebarSection__Caret",
  componentId: "sc-d8q54x-0"
})(["&&{&&{display:inline-flex;flex:0 0 16px;align-items:center;justify-content:center;width:16px;height:16px;margin:0;transform-origin:center;transition:transform 0.2s ease-out;transform:", ";color:rgba(0,0,0,0.35);svg{display:block;width:16px;height:16px;}}}"], props => props.open ? 'rotate(180deg)' : 'rotate(0deg)');
const SectionWrapper = styled(Box).withConfig({
  displayName: "SidebarSection__SectionWrapper",
  componentId: "sc-d8q54x-1"
})(["&&{position:relative;&.ude-measurement-header .section-header{background:#002766;border-bottom:none;margin-bottom:12px;}&.ude-measurement-header.ude-query-header .section-header{margin-bottom:0;}&.ude-measurement-header .section-header,&.ude-measurement-header .section-header .bp4-heading,&.ude-measurement-header .section-header .bp4-button,&.ude-measurement-header .section-header .bp4-button .bp4-icon{color:#fff;}&.ude-measurement-header .section-header .bp4-button .bp4-icon{color:rgba(255,255,255,0.85);}&.ude-measurement-header .bp4-popover-wrapper,&.ude-measurement-header .bp4-popover-target{display:flex;align-items:center;min-width:0;width:100%;}&.ude-measurement-header .ude-measurement-breadcrumb .bp4-popover-wrapper,&.ude-measurement-header .ude-measurement-breadcrumb .bp4-popover-target{display:inline-flex;width:auto;min-width:0;}.bp4-collapse{overflow:hidden !important;}.bp4-button.section-button{border-radius:0;}.section-content{scrollbar-width:thin;}.section-caret{opacity:0.35;}&:hover{.section-caret{opacity:1;}}}"]);
const SidebarSection = ({
  title,
  children,
  icon,
  iconProps,
  actions,
  className,
  defaultIsOpen = false,
  rightElement,
  isCollapsible = true,
  isOpen,
  maxHeight,
  pl = 2,
  pr = 2,
  ...rest
}) => {
  const [internalOpen, setInternalOpen] = React.useState(defaultIsOpen);
  const isControlled = isOpen !== undefined;
  const currentOpen = isControlled ? isOpen : internalOpen;
  const toggle = () => {
    if (!isControlled && isCollapsible) {
      setInternalOpen(!internalOpen);
    }
  };
  const heading = /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    minHeight: "20px"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: 1,
    flex: 1,
    minWidth: 0
  }, icon && /*#__PURE__*/React.createElement(Icon, _extends({
    icon: icon,
    size: 16,
    color: "kentik"
  }, iconProps)), typeof title === 'string' ? /*#__PURE__*/React.createElement(Heading, {
    level: 6,
    m: 0,
    flex: 1,
    fontSize: "13px",
    fontWeight: "500"
  }, title) : title, rightElement && rightElement), /*#__PURE__*/React.createElement(Flex, {
    gap: "4px",
    alignItems: "center"
  }, actions, isCollapsible && /*#__PURE__*/React.createElement(Caret, {
    className: "section-caret",
    open: currentOpen,
    icon: TbCaretDownFilled
  })));
  const body = /*#__PURE__*/React.createElement(Box, {
    className: "section-content",
    position: "relative",
    maxHeight: maxHeight
  }, children);
  return /*#__PURE__*/React.createElement(SectionWrapper, _extends({
    className: className,
    borderBottom: "thin",
    pb: currentOpen ? '12px' : 0
  }, rest), isCollapsible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: "section-button",
    large: true,
    fill: true,
    minimal: true,
    textAlign: "left",
    onClick: toggle,
    minHeight: "32px",
    pt: "3px",
    pb: "3px",
    pl: "16px",
    mb: currentOpen ? '2px' : 0
  }, heading), /*#__PURE__*/React.createElement(Collapse, {
    isOpen: currentOpen
  }, body)), !isCollapsible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    className: "section-header",
    pl: pl,
    pr: pr,
    py: 1
  }, heading), body));
};
export default SidebarSection;